import { invariant } from 'utils/invariant'

export const NEXT_PUBLIC_CF_URL = process.env.NEXT_PUBLIC_CF_URL
invariant(NEXT_PUBLIC_CF_URL, 'NEXT_PUBLIC_CF_URL is required within web/utils/config')

export const LFS_URL = process.env.NEXT_PUBLIC_LFS_URL
invariant(LFS_URL, 'NEXT_PUBLIC_LFS_URL is required within web/utils/config')

export const NEXT_PUBLIC_ASSET_BUCKET_URL = process.env.NEXT_PUBLIC_ASSET_BUCKET_URL
invariant(
  NEXT_PUBLIC_ASSET_BUCKET_URL,
  'NEXT_PUBLIC_ASSET_BUCKET_URL is required within web/utils/config',
)

export const NEXT_PUBLIC_CONTENT_IMAGES_ROOT_URL = process.env.NEXT_PUBLIC_CONTENT_IMAGES_ROOT_URL
invariant(
  NEXT_PUBLIC_CONTENT_IMAGES_ROOT_URL,
  'NEXT_PUBLIC_CONTENT_IMAGES_ROOT_URL is required within web/utils/config',
)

export const ALL_ACCESS_PRODUCT_REFERRAL_COOKIE_NAME =
  process.env.NEXT_PUBLIC_PROD_REFERRAL_COOKIE_NAME
invariant(
  ALL_ACCESS_PRODUCT_REFERRAL_COOKIE_NAME,
  'Missing NEXT_PUBLIC_PROD_REFERRAL_COOKIE_NAME inside /apps/web/hooks/use-buy-click.ts',
)
